import authService from '@/services/auth.service'

const state = {
  // Restore the cached profile together with the token. Without this, a hard
  // refresh kept the session alive but temporarily downgraded the navigation
  // because role-dependent menus saw a null user.
  user: authService.getUser(),
  token: sessionStorage.getItem('token') || localStorage.getItem('token') || null,
  isAuthenticated: !!(sessionStorage.getItem('token') || localStorage.getItem('token'))
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
  },
  SET_TOKEN(state, token) {
    state.token = token
    state.isAuthenticated = !!token
  },
  LOGOUT(state) {
    state.user = null
    state.token = null
    state.isAuthenticated = false
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('user')
  }
}

const actions = {
  async login({ commit, dispatch }, { username, password, remember }) {
    commit('SET_LOADING', true, { root: true })
    try {
      const user = await authService.login(username, password, remember)
      commit('SET_USER', user)
      commit('SET_TOKEN', authService.getToken())
      
      // Carregar leads após login bem-sucedido
      dispatch('leads/fetchLeads', null, { root: true })
      
      return user
    } catch (error) {
      commit('SET_ERROR', error.message || 'Falha ao fazer login', { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  
  async register({ commit }, { email, name, password, organizationName }) {
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await authService.register(email, name, password, organizationName)
      // Registration does not establish a session; preserve any active login.
      
      // Carregar leads após registro bem-sucedido
      
      return response
    } catch (error) {
      commit('SET_ERROR', error.message || 'Falha ao registrar', { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  
  async fetchCurrentUser({ commit, dispatch }) {
    commit('SET_LOADING', true, { root: true })
    try {
      const user = await authService.getCurrentUser()
      commit('SET_USER', user)
      return user
    } catch (error) {
      commit('SET_ERROR', error.message || 'Falha ao obter dados do usuário', { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false, { root: true })
    }
  },
  
  logout({ commit }) {
    authService.logout()
    commit('LOGOUT')
  }
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  currentUser: state => state.user,
  token: state => state.token,
  isAdmin: state => state.user && (state.user.is_admin || ['owner', 'admin'].includes(state.user.role))
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 
